import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import SearchLayoutComponent from '../../../../../../../core/layout-components/search';

const Card = styled(SegmentLayoutComponent)`
  &.ui.segment {
    margin-bottom: 25px;
    padding: 20px;
  }
`;

const Title = styled.h3`
  color: ${(props) => props.theme.color.textSecondary};
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 16px;
  font-family: Roboto;
`;

const TimeQuestion = styled.h4`
  color: ${(props) => props.theme.color.textSecondary};
`;

const Search = styled(SearchLayoutComponent).attrs({
  isWritten: true,
})``;

const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown > .text {
    color: ${(props) => props.theme.color.primary};
    font-weight: 500;
  }
`;

const ContainerDropdown = styled.div`
  margin-top: 15px;
  margin-bottom: 25px;
  display: inline-flex;
  align-items: center;
`;

const SelectedQuestion = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  overflow-wrap: anywhere;
  font-size: 16px;
  font-family: Roboto;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const QuestionInfo = styled.div`
  flex: 1;
  display: flex;
  padding-right: 10px;
  justify-content: end;
  align-items: start;
`;

const WatchQuestionLink = styled.a`
  font-weight: 500;
`;

const WrittenHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: space-between;
`;

const WrittenTitleContainer = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  margin-bottom: 20px;
`;

const WrittenQuestionOrder = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
`;

const WrittenTitle = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
  margin-top: 20px;
`;

const WrittenChartContent = styled.div`
  margin-top: 20px;
`;

export {
  Card,
  ContainerDropdown,
  Dropdown,
  HeaderContainer,
  Search,
  SelectedQuestion,
  Title,
  TimeQuestion,
  WatchQuestionLink,
  QuestionInfo,
  WrittenHeaderContainer,
  WrittenTitleContainer,
  WrittenQuestionOrder,
  WrittenTitle,
  WrittenChartContent,
};
